import React,{useEffect, useRef} from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useState } from 'react'
import TaskForm from '../components/TaskForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';



const CellActions = (props) =>{
    return(
        <>
            <TaskForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
        </>
    )
  }


function TaskListPage() {

  
  const {getMasterLabel,projectDD, taskList,getTaskList, getDDDataById} = useAppData();
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {headerName: "Project", width:250,
          valueGetter:params=>{
            return getDDDataById(projectDD,params.data.projectId).label;
          }
        },
        {field:"title",headerName: "Title",width:250},
        {field:"progress",headerName: "Progress",width:250},
        {headerName: "Status", width:150,
          valueGetter:params=>{
            return getMasterLabel('task-status',params.data.status)
          }
        },
        {headerName:"Action", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getTaskList,
                remove:remove
            },
        },      
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <ErpLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Task</h4></div>
        <div className='col-md-6'> 
          {/* <span className='float-end'><TaskForm callBack={getTaskList} /></span> */}
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={taskList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getTaskList}
              />
            </div>
          </div>
        </div>
    </ErpLayout>
    
  )
}

export default TaskListPage